const Footer = () => {
  return (
    <footer className="dashboard-footer">
      Presto v2 © 2025
    </footer>
  )
}
export default Footer